import { string, object, boolean } from "yup";

// Letters of any alphabet plus the separators real names use: space, hyphen,
// apostrophe and dot (Yılmaz, José, O'Brien, O’Brien, Dr. Müller)
const nameFieldRegex = /^[\p{L}\p{M}\s'’.-]+$/u;
const MIN_NAME_LETTERS = 2;

// iOS adds a trailing space after a word suggestion; trim and collapse the
// whitespace before validating so it never fails the name check
const normalizeWhitespace = (value) =>
  typeof value === "string" ? value.replace(/\s+/g, " ").trim() : value;

// Validates: local-part@domain-labels.TLD
// - Requires exactly one "@"
// - Domain must have at least one label after "@", with no empty labels
//   (blocks cases like "user@.com" or "user@sub..com")
// - Domain must end in a dot + TLD, where TLD starts with a letter
//   and can contain letters/digits/hyphens after that (supports
//   Punycode/IDN TLDs, e.g. "xn--p1ai")
// - Local part (before "@") allows dots (e.g. "john.doe@example.com")
const emailFieldRegex =
  /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)*\.[A-Za-z][A-Za-z0-9-]{1,}$/;

export const AnswerFormSchema = object().shape({
  answer: string().required("Bitte geben Sie eine Antwort ein")
});

export const ContactFormBaseSchema = object().shape({
  name: string()
    .transform(normalizeWhitespace)
    .required("Name ist erforderlich")
    .matches(nameFieldRegex, {
      message:
        "Bitte nur Buchstaben verwenden (keine Zahlen oder Sonderzeichen)",
      excludeEmptyString: true
    })
    .test(
      "min-letters",
      "Bitte geben Sie Ihren Namen ein",
      (value) =>
        !value || (value.match(/\p{L}/gu) || []).length >= MIN_NAME_LETTERS
    ),
  email: string()
    .trim()
    .required("Email ist erforderlich")
    .matches(emailFieldRegex, "Geben Sie eine gültige Email ein")
});

export const PhoneNumberSchema = object().shape({
  phone: string().required("Telefonnummer ist erforderlich")
});

export const ContactPhoneSchema = PhoneNumberSchema.concat(
  object().shape({
    policyCheck: boolean().when("policySectionDisplayDecider", {
      is: true,
      then: (schema) =>
        schema.oneOf([true], "*Bitte bestätigen Sie die Richtlinie."),
      otherwise: (schema) => schema.notRequired()
    })
  })
);

export const ContactFormCompleteSchema =
  ContactFormBaseSchema.concat(ContactPhoneSchema);

export const AddressSchema = object().shape({
  address: object().shape({
    description: string().required("Adresse ist erforderlich")
  })
});
